<template>
  <el-tooltip content="播放语音" placement="bottom">
    <img class="func-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/mp3.png" @click="onClick" />
  </el-tooltip>

</template>

<script>
export default {
  name: 'BoldMenuButton',
  props: ['isActive'],

  methods: {
    onClick (e) {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
.func-img{
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 8px;
  margin-top: 9px;
}
</style>
